module.exports = __webpack_public_path__ + "static/img/kapipo.bb12bb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/kapipo.png
// module id = 8Lo0
// module chunks = 0